
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { MapPin, RefreshCw } from "lucide-react";
import { useSitemapGeneration } from "@/hooks/useSitemapGeneration";

const SitemapGenerationButton = () => {
  const { 
    isGenerating, 
    generateSitemap 
  } = useSitemapGeneration();
  const { toast } = useToast();

  const handleGenerate = async () => {
    try {
      await generateSitemap();
      toast({
        title: "Sitemap Generated",
        description: "Sitemap and robots.txt have been generated successfully",
        variant: "default",
      });
    } catch (error) {
      console.error('Error generating sitemap:', error);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          Generate Sitemap
        </CardTitle>
        <CardDescription>
          Generate sitemap.xml and robots.txt files for search engines
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button 
          onClick={handleGenerate} 
          disabled={isGenerating}
          className="w-full"
        >
          {isGenerating ? (
            <>
              <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
              Generating...
            </>
          ) : (
            <>
              <MapPin className="mr-2 h-4 w-4" />
              Generate Sitemap
            </>
          )}
        </Button>
        
        <div className="text-xs text-muted-foreground mt-4">
          <p>This will generate fresh sitemap.xml and robots.txt files based on your current content and publish them with your Cloudflare-hosted site assets.</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default SitemapGenerationButton;
